import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertSubTemplateEditing from './insertsubtemplateediting';

export default class InsertSubTemplate extends Plugin {
  static get pluginName() {
    return 'InsertSubTemplate';
  }
  static get requires() {
    return [ InsertSubTemplateEditing ];
  }
}